import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=3b0e7d96&"
import script from "./Lesson.vue?vue&type=script&lang=js&"
export * from "./Lesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports